import React, { useState, FC, useEffect, useMemo } from 'react';
import { Icon, Modal, Button, Bubble } from 'tea-component';
import type { BubbleContentProps  } from 'tea-component'
import { useIntl, history, useLocation } from 'umi';
import privacy from '@intelligence/assets/svg/menu/privacy.svg';
import privacyBlue from '@intelligence/assets/svg/menu/privacy_blue.svg';
import creditability from '@intelligence/assets/svg/menu/creditability_new.svg';
import creditabilityBlue from '@intelligence/assets/svg/menu/creditability_blue_new.svg';
import { MENUS_FOOTER_RED_MARK_MAPPING } from '@intelligence/_config/newMarks';
import { buriedPointPage } from '@/pages/home/utils/buriedPoint';
import { dbiPageLogMes } from '@/pages/intelligence/utils/buriedPointCfg';
import useNewMark from '@intelligence/hooks/useNewMark';
import useConfigureTexts from '@intelligence/hooks/useConfigureTexts';
import useDataPrivacy from './_hooks/useDataPrivacy';
import { has } from 'lodash-es'
import classnames from 'classnames';
import { getSanitizeHTMLString } from '@intelligence/v3/utils/common';
import { NewMarkDisplayMode, NewMarkType } from '@intelligence/enums/common';
import './MenuFooter.scss';

interface FooterLinkItem {
  hoverTip: string;
  placement?: BubbleContentProps['placement'];
  showMarkPoint?: boolean;
  placementOffset?: string | number | [string | number, string | number] | undefined;
  imageSource: [string, string];
  isHighlight: boolean;
  onClick: () => void;
}

export const METRICS_CREDITABILITY_URL = '/intelligence/MetricsCreditability';
export const CREDITABILITY_NAME = 'MetricsCreditability';
export const PRIVACY_NAME = 'DataPrivacy';

export const FooterLinkItem: FC<FooterLinkItem> = (props) => {
  const { hoverTip, imageSource, placement = 'top', onClick, isHighlight, placementOffset, showMarkPoint = false } = props;
  return (
    <a
      className={classnames([
        'dbi-left-menu-footer-warp-link',
        {
          'is-highlight': isHighlight,
        },
      ])}
      onClick={onClick}
    >
      <Bubble dark content={hoverTip} placement={placement} placementOffset={placementOffset}>
        <img src={imageSource[0]} className="common" width={16}/>
        <img src={imageSource[1]} className="is-select" width={16}/>
      </Bubble>
      {
        showMarkPoint && <div className='dbi-menu-mark-read-point'></div>
      }
    </a>
  );
};

export const MenuFooter: FC = () => {
  const { loading: configureTextsLoading, configureTexts } = useConfigureTexts();
  const { visible: isModalVisible, setVisible: setModalVisible, onClose } = useDataPrivacy({ loading: configureTextsLoading });

  const { formatMessage } = useIntl();
  const { newMarksState, addNewMarkRecord } = useNewMark();

  const { pathname } = useLocation();

  const delateMarkPoint = (id: string)=> {
    if(!id) return;
    if(!has(newMarksState, id)) return;

    addNewMarkRecord?.({
      newMarkDisplayMode: NewMarkDisplayMode.RecordControlled,
      // 这里固定为0，因为添加的时候也时固定0，这里不需要展示BETA、NEW，展示小红点，所以固定一个值就好
      newMarkType: NewMarkType.New,
      newMarkId: id,
    });
  }

  const handleDataPrivacyClick = ()=> {
    setModalVisible(true);
    delateMarkPoint(MENUS_FOOTER_RED_MARK_MAPPING[PRIVACY_NAME]);
    const pageMsg = dbiPageLogMes?.dataPrivacy;
    if(pageMsg) {
      buriedPointPage(pageMsg);
    }
  }


  const goMetricsCreditability = () => {
    history.push(METRICS_CREDITABILITY_URL);
    delateMarkPoint(MENUS_FOOTER_RED_MARK_MAPPING[CREDITABILITY_NAME]);
  };


  // const markPointConfig = useMemo(()=> {
  //   let config = {
  //     [CREDITABILITY_NAME]: false,
  //     [PRIVACY_NAME]: false
  //   }

  //   if(has(newMarksState, MENUS_FOOTER_RED_MARK_MAPPING[CREDITABILITY_NAME])){
  //     config[CREDITABILITY_NAME] = newMarksState?.[MENUS_FOOTER_RED_MARK_MAPPING[CREDITABILITY_NAME]]
  //   }

  //   if(has(newMarksState, MENUS_FOOTER_RED_MARK_MAPPING[PRIVACY_NAME])){
  //     config[PRIVACY_NAME] = newMarksState?.[MENUS_FOOTER_RED_MARK_MAPPING[PRIVACY_NAME]]
  //   }

  //   return config;

  // }, [newMarksState])

  return (
    <>
      <div className="dbi-left-menu-footer-warp">
        <FooterLinkItem
          placement="top-start"
          placementOffset={[-15, 20]}
          isHighlight={pathname === METRICS_CREDITABILITY_URL}
          onClick={goMetricsCreditability}
          // showMarkPoint={newMarksState?.[MENUS_FOOTER_RED_MARK_MAPPING[CREDITABILITY_NAME]] || false}
          showMarkPoint={has(newMarksState, MENUS_FOOTER_RED_MARK_MAPPING[CREDITABILITY_NAME])}
          imageSource={[creditability, creditabilityBlue]}
          hoverTip={formatMessage({ id: 'dbi_metrics_creditability_title' })}
        />
        <FooterLinkItem
          placementOffset={[0, 20]}
          isHighlight={isModalVisible}
          // showMarkPoint={newMarksState?.[MENUS_FOOTER_RED_MARK_MAPPING[PRIVACY_NAME]] || false}
          showMarkPoint={has(newMarksState, MENUS_FOOTER_RED_MARK_MAPPING[PRIVACY_NAME])}
          onClick={handleDataPrivacyClick}
          imageSource={[privacy, privacyBlue]}
          hoverTip={formatMessage({ id: 'dbi_data_privacy' })}
        />
      </div>
      <Modal
        className="dbi-data-privacy-modal"
        size={600}
        visible={isModalVisible}
        onClose={onClose}
        caption={
          <div className="dbi-data-privacy-modal__title-wrapper">
            <Icon className="dbi-data-privacy-modal__title-icon" type="error" size={20} />
            <span>{formatMessage({ id: 'dbi_data_privacy' })}</span>
          </div>
        }
      >
        <Modal.Body>
          <div dangerouslySetInnerHTML={{ __html: getSanitizeHTMLString(configureTexts?.intelligence_data_privacy_content) }} />
        </Modal.Body>
        <Modal.Footer>
          <Button type="primary" onClick={onClose}>
            {formatMessage({ id: 'dbi_data_privacy_got_it' })}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
